import React from 'react';
import Navbar from "common/Navbar";
import SiteFooter from "common/SiteFooter";
import DistrictSeriesBusesKolkataHowrah from "pages/DistrictSeriesBusesKolkataHowrah";
import GeneralPrivateBusesKolkataHowrah from "pages/GeneralPrivateBusesKolkataHowrah";
import GeneralPrivateBusesOtherDistricts from "pages/GeneralPrivateBusesOtherDistricts";
import GovernmentACBusesKolkataHowrah from "pages/GovernmentACBusesKolkataHowrah";
import GovernmentNonACBusesKolkataHowrah from "pages/GovernmentNonACBusesKolkataHowrah";
import Home from "pages/Home";
import KolkataTrams from "pages/KolkataTrams";
import MiscellaneousPrivateBusesKolkataHowrah from "pages/MiscellaneousPrivateBusesKolkataHowrah";
import VehicleRouteDetails from "pages/VehicleRouteDetails";
import VehicleRoutesSearch from "pages/VehicleRoutesSearch";

const componentMap = {
  'react-root-home': Home,
  'react-root-kolkata-trams': KolkataTrams,
  'react-root-general-private-buses-kolkata-howrah': GeneralPrivateBusesKolkataHowrah,
  'react-root-district-series-buses-kolkata-howrah': DistrictSeriesBusesKolkataHowrah,
  'react-root-miscellaneous-private-buses-kolkata-howrah': MiscellaneousPrivateBusesKolkataHowrah,
  'react-root-general-private-buses-other-districts': GeneralPrivateBusesOtherDistricts,
  'react-root-government-non-ac-buses-kolkata-howrah': GovernmentNonACBusesKolkataHowrah,
  'react-root-government-ac-buses-kolkata-howrah': GovernmentACBusesKolkataHowrah,
  'react-root-search-for-routes': VehicleRoutesSearch,
  'react-root-vehicle-route-details': VehicleRouteDetails,
};

function App({ divId }) {
  const PageComponent = divId ? componentMap[divId] : null;

  return (
    <>
      <Navbar />
      <div id="content">
        {PageComponent ? <PageComponent /> : <div>Page not found</div>}
      </div>
      <SiteFooter />
    </>
  );
}

export default App;
